import "./OurCraft.module.css";
import MainNavigation from "@/reusable_sections/Header";
import FullServiceSpectrum from "./sections/FullServiceSpectrum";
import OurSpecializedEquipment from "./sections/OurSpecializedEquipment";
import SiteFooter from "@/reusable_sections/Footer";
export default function OurCraftPage() {
  return <div>
      <MainNavigation />
      <FullServiceSpectrum />
      <OurSpecializedEquipment />
      <SiteFooter />
    </div>;
}